module.exports = __webpack_public_path__ + "img/4f823ed.jpg";